/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';

/**
 * Internal dependencies
 */
import { tickIcon, crossIcon } from '../../../assets/icons';

export default function FeatureComparisonTable({ blockType }) {
    // Define the data for each block type
    const blockData = {
        tableBuilder: {
            title: __('Table Builder Block'),
            features: [
                { label: __('Elements'), free: __('6'), pro: __('12') },
                { label: __('Text'), free: tickIcon, pro: tickIcon },
                { label: __('Image'), free: tickIcon, pro: tickIcon },
                { label: __('Button'), free: tickIcon, pro: tickIcon },
                { label: __('List'), free: tickIcon, pro: tickIcon },
                { label: __('Icon'), free: tickIcon, pro: tickIcon },
                { label: __('Shortcode'), free: tickIcon, pro: tickIcon },
                { label: __('Advanced Text'), free: crossIcon, pro: tickIcon },
                { label: __('Icon List'), free: crossIcon, pro: tickIcon },
                { label: __('Icon Button'), free: crossIcon, pro: tickIcon },
                { label: __('Dual Button'), free: crossIcon, pro: tickIcon },
                { label: __('Star Rating'), free: crossIcon, pro: tickIcon },
                { label: __('Divider'), free: crossIcon, pro: tickIcon },
            ],
        },
		pricingTable: {
            title: __('Pricing Table Block'),
            features: [
                { label: __('Elements'), free: '4', pro: '7' },
                { label: __('Title & Subtitle'), free: tickIcon, pro: tickIcon },
                { label: __('Price Element'), free: tickIcon, pro: tickIcon },
                { label: __('Features List'), free: tickIcon, pro: tickIcon },
                { label: __('Action Button'), free: tickIcon, pro: tickIcon },
                { label: __('Media Element (image, icon)'), free: crossIcon, pro: tickIcon },
                { label: __('Star Rating'), free: crossIcon, pro: tickIcon },
                { label: __('Divider'), free: crossIcon, pro: tickIcon },
                { label: __('Pricing Plan Toggle'), free: crossIcon, pro: tickIcon },
                { label: __('Featured Column'), free: crossIcon, pro: tickIcon },
				{ label: __('Media(img/icon) support with Title Element'), free: crossIcon, pro: tickIcon },
                { label: __('Original Price, Price Suffix and Dynamic Price Slider with Pricing Element'), free: crossIcon, pro: tickIcon },
                { label: __('Icon support, Tooltip, Badge with Features Element'), free: crossIcon, pro: tickIcon },
                { label: __('Icon support with Button Element'), free: crossIcon, pro: tickIcon },
                { label: __('Background Image support for Column'), free: crossIcon, pro: tickIcon },
                { label: __('Ribbon Style'), free: '2', pro: '5' },
            ],
        },
        prosAndCons: {
            title: __('Pros and Cons Block'),
            features: [
                { label: __('Enable Schema'), free: tickIcon, pro: tickIcon },
                { label: __('Default Responsive Settings'), free: tickIcon, pro: tickIcon },
                { label: __('Header and Body Item Icon Placement'), free: crossIcon, pro: tickIcon },
                { label: __('Title Separator'), free: crossIcon, pro: tickIcon },
                { label: __('Flexible Header Positioning'), free: crossIcon, pro: tickIcon },
                { label: __('Enable Stripe on Body Items'), free: crossIcon, pro: tickIcon },
                { label: __('Advanced Border Styles with 8 Stunning Design Pattern'), free: crossIcon, pro: tickIcon },
                { label: __('Extra Design Flexibility in Style Options'), free: crossIcon, pro: tickIcon },
            ],
        },
    };

    // Get the data for the selected block type
    const { title, features } = blockData[blockType] || { title: '', features: [] };

    return (
        <div className="rv-tb-free-pro-content">
            <div className="rv-tb-free-pro-elements">
                <div><h2>{title}</h2></div>
                <table>
                    <thead>
                        <tr>
                            <th>{__('Features')}</th>
                            <th>{__('Free')}</th>
                            <th>{__('Pro')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {features.map((feature, index) => (
                            <tr key={index}>
                                <td>{feature.label}</td>
                                <td>{feature.free}</td>
                                <td>{feature.pro}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
